import React from 'react';
import { Typography as MuiTypography } from '@mui/material';

const fontSizeMap = {
  small: '14px',
  smallMedium: '15px',
  medium: '17px',
  mediumSmall: '16px',
  large: '20px',
  xlarge: '24px',
};

const fontWeightMap = {
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extraBold: 800,
};

const CustomTypography = ({
  variant = 'body1',
  size = 'medium',
  color = 'default',
  weight = 'normal',
  children,
  ...props
}) => {
  const fontSize = fontSizeMap[size] || fontSizeMap.medium;
  const fontWeight = fontWeightMap[weight] || fontWeightMap.normal;

  let textColor;
  switch (color) {
    case 'primary':
      textColor = 'var(--primary)';
      break;
    case 'sub-primary':
      textColor = 'var(--sub-primary)';
      break;
    case 'secondary':
      textColor = 'var(--text-secondary)';
      break;
    case 'error':
      textColor = 'var(--text-error)';
      break;
    default:
      textColor = '#000';
      break;
  }

  return (
    <MuiTypography
      variant={variant}
      noWrap={false}
      style={{
        fontSize,
        color: textColor,
        fontFamily: "'Poppins', sans-serif",
        fontWeight,
      }}
      {...props}
    >
      {children}
    </MuiTypography>
  );
};

export default CustomTypography;
